module.exports = __webpack_public_path__ + "img/h_logo_ebn.f7ef984f.png";